
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { append as append_1, choose, collect, exists, sumBy, reduce, isEmpty, map, singleton as singleton_1, empty as empty_1, take, length, tryHead, contains, filter, ofArray, toArray, sortByDescending } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { toLocalTime, toString, utcNow, date as date_3, compare } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { DeleteReminder_OpenDialog, ConfirmDialog_ConfirmReminderDialog, EditReminder_OpenDialog, NewReminder_OpenDialog } from "../Dialogs/AddReminderDialog.js";
import { Msg } from "./Types.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { StorageId__get_unwrap, StorageId as StorageId_2, DocumentId__get_unwrap, ToolId as ToolId_4 } from "../../../Shared/Shared.js";
import { flatten, map as map_1, defaultArg, unwrap } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { TableControl$1, Table } from "../../../Widgets/Table/Table.js";
import { ColoredDot } from "../../../Components/ColoredDot.js";
import { ColumnDefinition$1, CellContent } from "../../../Widgets/Table/Types.js";
import { safeHash, equals, int32ToString, stringHash, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { split, concat, join } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import Calendar_Warning from "../../../../public/assets/icons/Calendar_Warning.svg";
import { FileDialog_LinkedDocumentToolType, FileDialog_LinkedEntityId, Modal_OpenLinkedDocumentModalButtonModalSheet } from "../../../Widgets/Modals/LinkedDocumentModal.js";
import { OpenChangelogButtonModalSheet } from "../../../Widgets/Modals/ChangelogModal.js";
import { Feature, isFeatureEnabled } from "../../../FeatureFlip.js";
import Calendar_Add from "../../../../public/assets/icons/Calendar_Add.svg";
import Pencil from "../../../../public/assets/icons/Pencil.svg";
import Check from "../../../../public/assets/icons/Check.svg";
import Recycle_Bin_1 from "../../../../public/assets/icons/Recycle_Bin_1.svg";
import { TextButton, Button } from "../../../Components/Button.js";
import { ModalSheet } from "../../../Components/ModalSheet.js";
import { NewReservation_AddToolWithQuantityReservationDialog } from "../Dialogs/ToolWithQuantityReservationDialog.js";
import { EditToolWithQuantityReservationDialog } from "../Dialogs/EditToolWithQuantityReservationDialog.js";
import { DeleteToolWithQuantityReservationDialog } from "../Dialogs/ToolWithQuantityDeleteReservation.js";
import { Record } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, string_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { DocumentTable } from "../../../Widgets/Table/DocumentTable.js";
import { UploadType as UploadType_2 } from "../../../Widgets/Dialogs/FileUploadDialog.js";
import Warehouse_1 from "../../../../public/assets/icons/Warehouse_1.svg";
import Location_Building_Search from "../../../../public/assets/icons/Location_Building_Search.svg";
import Transfer_Cart from "../../../../public/assets/icons/Transfer_Cart.svg";
import Notification_Alarm_1 from "../../../../public/assets/icons/Notification_Alarm_1.svg";
import { ToolWithQuantityStockPerStorageDeleteDialog } from "../Dialogs/ToolWithQuantityDeleteStockPerStorageDialog.js";
import { MinimumStockQuantityDialog } from "../Dialogs/MinimumStockQuantityDialog.js";
import { ChangeStockDialog } from "../Dialogs/StockChangeDialog.js";
import { ChangeStorageSpaceDialog } from "../Dialogs/ChangeStorageSpaceDialog.js";
import { ChangeStorageDialog } from "../Dialogs/SwitchStorageDialog.js";
import { ToolWithQuantityDetailDto__ReadableDisplayName, ToolWithQuantityState, Helper_historyTypeToTranslationString } from "../../../Shared/Tool.js";
import { Helper_displayHistoryComment } from "../../../Shared/Changelog.js";
import { AssignmentProtocolDialog, AssignmentProtocolParams } from "../../../Widgets/AssignmentProtocol.js";
import { PropertyList } from "../../../Widgets/PropertyListWidget.js";
import { CustomPropertiesPropertyList } from "../../../Widgets/CustomPropertiesPropertyList.js";
import { getQueryParams, priceToString } from "../../../Common.js";
import { AreaAnchorMenu } from "../../../Widgets/AnchorMenu.js";
import Following from "../../../../public/assets/icons/Following.svg";
import Followers from "../../../../public/assets/icons/Followers.svg";
import { AssignToolWithQuantityDialog } from "../Dialogs/AssignToolWithQuantityDialog.js";
import { UnassignToolWithQuantityDialog } from "../Dialogs/UnassignToolWithQuantityDialog.js";
import { LostToolWithQuantityDialog } from "../Dialogs/LostToolWithQuantityDialog.js";
import { ReturnToolWithQuantityNotificationDialog } from "../Dialogs/ReturnToolWithQuantityNotificationDialog.js";
import { SelfServiceAssignToolWithQuantityDialog } from "../Dialogs/SelfServiceAssignToolWithQuantityDialog.js";
import { unwrapStorageId } from "../../../Shared/Helper.js";
import { SelfServiceReturnToolWithQuantityDialog } from "../Dialogs/SelfServiceReturnToolWithQuantityDialog.js";
import Shipment_Search from "../../../../public/assets/icons/Shipment_Search.svg";
import { StateChangeDialog } from "../Dialogs/StateChangeDialog.js";
import Shipment_Check from "../../../../public/assets/icons/Shipment_Check.svg";
import Shipment_Delivery_Fail from "../../../../public/assets/icons/Shipment_Delivery_Fail.svg";
import { NotificationArea } from "../../../Widgets/Notification/NotificationArea.js";
import { NotificationToolType as NotificationToolType_1 } from "../../../Widgets/Notification/AcceptNotificationDialog.js";
import { MultipleImageWidget } from "../../../Widgets/Image/ImageWidget.js";
import { TextValue } from "../../../Components/Text.js";
import { QuickOverviewList } from "../../../Widgets/QuickOverviewList.js";
import { QrCodeTableWithStorage } from "../../../Widgets/Table/QrCodeTable.js";
import { OpenToolWithQuantityDeleteDialog } from "../Dialogs/ToolWithQuantityDeleteDialog.js";
import { DetailViewHeader } from "../../../Widgets/DetailViewHeader.js";
import { Badge } from "../../../Components/Badge.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { TableContainerWithTabs, TableContainer } from "../../../Widgets/Container.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { ChangelogTable } from "../../../Widgets/Table/ChangelogTable.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { update as update_1, initViewToolWithQuantity } from "./State.js";

function AppointmentsSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReminderDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReminderToConfirm = patternInput_3[1];
    const selectedReminderToConfirm = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedReminder = patternInput_4[1];
    const selectedReminder = patternInput_4[0];
    const patternInput_5 = reactApi.useState(undefined);
    const setSelectedDeleteReminder = patternInput_5[1];
    const selectedDeleteReminder = patternInput_5[0];
    const reminders = sortByDescending((r) => r.Date, props.ToolWithQuantity.Reminders, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const now = date_3(utcNow());
    const xs_3 = toList(delay(() => append(singleton(createElement(NewReminder_OpenDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReminderDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
    })), delay(() => append(singleton(createElement(EditReminder_OpenDialog, {
        IsOpen: selectedReminder != null,
        OnClose: () => {
            setSelectedReminder(undefined);
        },
        Reminder: unwrap(selectedReminder),
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
    })), delay(() => {
        let matchValue;
        return append((matchValue = selectedReminderToConfirm, (matchValue == null) ? (empty()) : append(singleton(createElement(ConfirmDialog_ConfirmReminderDialog, {
            IsOpen: selectedReminderToConfirm != null,
            OnClose: () => {
                setSelectedReminderToConfirm(undefined);
            },
            Reminder: matchValue,
            SuccessCallback: (isFileUploaded) => {
                props.Dispatch(new Msg(9, []));
                if (isFileUploaded) {
                    props.Dispatch(new Msg(28, []));
                }
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        })), delay(() => singleton(defaultOf())))), delay(() => append((selectedDeleteReminder != null) ? singleton(createElement(DeleteReminder_OpenDialog, {
            IsOpen: selectedDeleteReminder != null,
            OnClose: () => {
                setSelectedDeleteReminder(undefined);
            },
            Reminder: unwrap(selectedDeleteReminder),
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
                props.Dispatch(new Msg(28, []));
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        })) : empty(), delay(() => {
            let elems_2;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["data", "desc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("state", "", t("general.done"), (reminderDate) => {
                        let elems;
                        return reminderDate.IsConfirmed ? (new CellContent(1, [createElement(ColoredDot, {
                            Color: "green",
                        })])) : ((compare(reminderDate.Date, now) > 0) ? (new CellContent(1, [createElement(ColoredDot, {
                            Color: "orange",
                        })])) : (new CellContent(1, [reactElement("div", createObj(ofArray([["className", join(" ", ["text-red", "h-5", "w-5"])], (elems = [Calendar_Warning()], ["children", reactApi.Children.toArray(Array.from(elems))])])))])));
                    }, "none", "text"), new ColumnDefinition$1("date", "", t("general.planned_date"), (dto) => (new CellContent(6, [dto.Date])), "dateRange", "date"), new ColumnDefinition$1("executionDate", "", t("general.execution_date"), (dto_1) => (new CellContent(6, [dto_1.ExecutionDate])), "dateRange", "date"), new ColumnDefinition$1("name", "", t("general.name"), (dto_2) => (new CellContent(0, [dto_2.Title])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_3) => (new CellContent(0, [dto_3.Description])), "none", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_4) => (new CellContent(0, [dto_4.ConfirmationComment])), "none", "text"), new ColumnDefinition$1("hasDocumentLinked", "", t("document_reminder_relation.documents_link"), (dto_5) => (new CellContent(1, [createElement(Modal_OpenLinkedDocumentModalButtonModalSheet, {
                        Documents: filter((doc) => contains(DocumentId__get_unwrap(doc.Id), dto_5.DocumentIds, {
                            Equals: (x_1, y_1) => (x_1 === y_1),
                            GetHashCode: (x_1) => (stringHash(x_1) | 0),
                        }), props.Documents),
                        LinkedEntityId: new FileDialog_LinkedEntityId(0, [dto_5.Id]),
                        OnClose: () => {
                            props.Dispatch(new Msg(28, []));
                            props.Dispatch(new Msg(9, []));
                        },
                        UploadType: new FileDialog_LinkedDocumentToolType(2, [new ToolId_4(parse(props.ToolWithQuantity.Id))]),
                        UserData: props.UserData,
                    })])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_6) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_6.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => {
                        let matchValue_1;
                        return append(isFeatureEnabled(new Feature(8, [])) ? ((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                            setIsReminderDialogOpen(true);
                        }, false, false, "table-reminder")) : ((matchValue_1 === "toolManager") ? singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                            setIsReminderDialogOpen(true);
                        }, false, false, "table-reminder")) : ((matchValue_1 === "user") ? (empty()) : singleton(new TableControl$1(t("dialog.reminder.btn_title"), Calendar_Add(), (_arg_8) => {
                            setIsReminderDialogOpen(true);
                        }, false, false, "table-reminder")))))) : empty(), delay(() => {
                            let matchValue_2;
                            return append((matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    const planning = selectedRow;
                                    const matchValue_3 = props.UserData.Role;
                                    switch (matchValue_3) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedReminder(planning);
                                    }
                                }
                            }, true, false, "table-edit")) : ((matchValue_2 === "toolManager") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    const planning = selectedRow;
                                    const matchValue_3 = props.UserData.Role;
                                    switch (matchValue_3) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedReminder(planning);
                                    }
                                }
                            }, true, false, "table-edit")) : ((matchValue_2 === "user") ? (empty()) : singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                                const selectedRow = tryHead(rows_1);
                                if (selectedRow == null) {
                                }
                                else {
                                    const planning = selectedRow;
                                    const matchValue_3 = props.UserData.Role;
                                    switch (matchValue_3) {
                                        case "user": {
                                            break;
                                        }
                                        default:
                                            setSelectedReminder(planning);
                                    }
                                }
                            }, true, false, "table-edit"))))), delay(() => {
                                let matchValue_4;
                                return append((matchValue_4 = props.UserData.Role, (matchValue_4 === "system") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, true, false, "table-mark-as-done")) : ((matchValue_4 === "administrator") ? singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, true, false, "table-mark-as-done")) : ((matchValue_4 === "user") ? (empty()) : singleton(new TableControl$1(t("general.mark_as_done"), Check(), (rows_2) => {
                                    const selectedRow_1 = tryHead(rows_2);
                                    if (selectedRow_1 != null) {
                                        setSelectedReminderToConfirm(selectedRow_1);
                                    }
                                }, true, false, "table-mark-as-done"))))), delay(() => {
                                    const matchValue_5 = props.UserData.Role;
                                    switch (matchValue_5) {
                                        case "user": {
                                            return empty();
                                        }
                                        default:
                                            return singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_3) => {
                                                const selectedRow_3 = tryHead(rows_3);
                                                if (selectedRow_3 == null) {
                                                }
                                                else {
                                                    const planning_1 = selectedRow_3;
                                                    const matchValue_6 = props.UserData.Role;
                                                    switch (matchValue_6) {
                                                        case "user": {
                                                            break;
                                                        }
                                                        default:
                                                            setSelectedDeleteReminder(planning_1);
                                                    }
                                                }
                                            }, true, false, "table-delete"));
                                    }
                                }));
                            }));
                        }));
                    })),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_2 = toList(delay(() => append(singleton(table((length(reminders) > 5) ? take(5, reminders) : reminders)), delay(() => {
                let elems_1;
                return (length(reminders) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems_1 = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "tool-with-quantity-appointment-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reminders),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("general.appointments"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }))));
    }))))));
    return react.createElement(react.Fragment, {}, ...xs_3);
}

function ReservationSection(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const setIsReservationDialogOpen = patternInput_2[1];
    const patternInput_3 = reactApi.useState(undefined);
    const setSelectedReservation = patternInput_3[1];
    const patternInput_4 = reactApi.useState(undefined);
    const setSelectedDeleteReservation = patternInput_4[1];
    const selectedDeleteReservation = patternInput_4[0];
    const reservations = sortByDescending((r) => r.StartDate, props.ToolWithQuantity.Reservations, {
        Compare: (x, y) => (compare(x, y) | 0),
    });
    const now = date_3(utcNow());
    const xs_2 = toList(delay(() => append(singleton(createElement(NewReservation_AddToolWithQuantityReservationDialog, {
        IsOpen: patternInput_2[0],
        OnClose: () => {
            setIsReservationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
        UserData: props.UserData,
    })), delay(() => {
        let matchValue;
        return append((matchValue = patternInput_3[0], (matchValue == null) ? (empty()) : singleton(createElement(EditToolWithQuantityReservationDialog, {
            IsOpen: true,
            OnClose: () => {
                setSelectedReservation(undefined);
            },
            ReservationId: matchValue.Id,
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
            },
            ToolId: new ToolId_4(parse(props.ToolWithQuantity.Id)),
            UserData: props.UserData,
        }))), delay(() => append((selectedDeleteReservation != null) ? singleton(createElement(DeleteToolWithQuantityReservationDialog, {
            IsOpen: selectedDeleteReservation != null,
            OnClose: () => {
                setSelectedDeleteReservation(undefined);
            },
            Reservation: unwrap(selectedDeleteReservation),
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
            },
            ToolWithQuantity: props.ToolWithQuantity,
            UserData: props.UserData,
        })) : empty(), delay(() => {
            let elems_1;
            const table = (rows) => {
                let TableRows, Options;
                return createElement(Table, (TableRows = toArray(rows), (Options = {
                    BorderStyle: "row",
                    CSVDownload: false,
                    ConfigurableColumns: false,
                    CustomTableFilters: false,
                    DefaultSortColumn: ["startDate", "asc"],
                    Fullscreen: false,
                    GlobalSearch: false,
                    RowSelection: "singleRow",
                    SaveTableConfiguration: false,
                }, {
                    ColumnDefinitions: [new ColumnDefinition$1("startDate", "", t("general.start_date"), (dto) => (new CellContent(6, [dto.StartDate])), "dateRange", "date"), new ColumnDefinition$1("endDate", "", t("general.end_date"), (dto_1) => (new CellContent(6, [dto_1.EndDate])), "dateRange", "date"), new ColumnDefinition$1("receiverName", "", t("general.receiver"), (dto_2) => (new CellContent(0, [dto_2.ReceiverInformation.ReceiverName])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity"), (dto_3) => (new CellContent(0, [int32ToString(dto_3.Quantity)])), "text", "text"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_4) => (new CellContent(0, [dto_4.StorageName])), "select", "text"), new ColumnDefinition$1("reservationName", "", t("general.name"), (dto_5) => (new CellContent(0, [dto_5.Name])), "none", "text"), new ColumnDefinition$1("description", "", t("general.description"), (dto_6) => (new CellContent(0, [dto_6.Description])), "none", "text"), new ColumnDefinition$1("sender", "", t("general.created_by"), (dto_7) => (new CellContent(0, [dto_7.SenderInformation.SenderName])), "none", "text"), new ColumnDefinition$1("changelog-history", "", t(""), (dto_8) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: dto_8.Id,
                    })])), "none", "button")],
                    Controls: toList(delay(() => append(isFeatureEnabled(new Feature(9, [])) ? singleton(new TableControl$1(t("dialog.reservation.btn_title"), Calendar_Add(), (_arg_6) => {
                        setIsReservationDialogOpen(true);
                    }, false, false, "table-reservation")) : empty(), delay(() => {
                        let matchValue_1;
                        return append((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit")) : ((matchValue_1 === "toolManager") ? singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit")) : ((matchValue_1 === "user") ? (empty()) : singleton(new TableControl$1(t("general.edit"), Pencil(), (rows_1) => {
                            const selectedRow = tryHead(rows_1);
                            if (selectedRow == null) {
                            }
                            else {
                                const planning = selectedRow;
                                const matchValue_2 = props.UserData.Role;
                                switch (matchValue_2) {
                                    case "user": {
                                        if (planning.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                            setSelectedReservation(planning);
                                        }
                                        break;
                                    }
                                    default:
                                        setSelectedReservation(planning);
                                }
                            }
                        }, true, false, "table-edit"))))), delay(() => {
                            const matchValue_3 = props.UserData.Role;
                            switch (matchValue_3) {
                                case "user": {
                                    return empty();
                                }
                                default:
                                    return singleton(new TableControl$1(t("general.delete"), Recycle_Bin_1(), (rows_2) => {
                                        const selectedRow_1 = tryHead(rows_2);
                                        if (selectedRow_1 == null) {
                                        }
                                        else {
                                            const planning_1 = selectedRow_1;
                                            const matchValue_4 = props.UserData.Role;
                                            switch (matchValue_4) {
                                                case "user": {
                                                    if (planning_1.ReceiverInformation.ReceiverId === props.UserData.UserId) {
                                                        setSelectedDeleteReservation(planning_1);
                                                    }
                                                    break;
                                                }
                                                default:
                                                    setSelectedDeleteReservation(planning_1);
                                            }
                                        }
                                    }, true, false, "table-delete"));
                            }
                        }));
                    })))),
                    Options: Options,
                    TableKey: "not-defined-table",
                    TableRows: TableRows,
                })));
            };
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(table((length(reservations) > 5) ? take(5, reservations) : reservations)), delay(() => {
                let elems;
                return (length(reservations) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                    ComponentState: "enabled",
                    Label: t("general.show_more_data"),
                    OnClick: () => {
                        setIsModalOpen(true);
                    },
                    TestId: "tool-with-quantity-reservations-showmoredata-button",
                    Variant: "blueButton",
                }), createElement(ModalSheet, {
                    CloseButtonTestId: "",
                    Content: table(reservations),
                    Controls: empty_1(),
                    IsModalOpen: patternInput_1[0],
                    OnClose: () => {
                        setIsModalOpen(false);
                    },
                    Title: t("navbar.reservation"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
        }))));
    }))));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

export function FormModal(props) {
    let elems;
    return reactElement("div", createObj(singleton_1((elems = [createElement(ModalSheet, {
        CloseButtonTestId: "",
        Content: defaultOf(),
        Controls: empty_1(),
        IsModalOpen: props.IsOpen,
        OnClose: props.OnClose,
    })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export class CurrentUserAssignment extends Record {
    constructor(Id, Name, Quantity) {
        super();
        this.Id = Id;
        this.Name = Name;
        this.Quantity = Quantity;
    }
}

export function CurrentUserAssignment_$reflection() {
    return record_type("Tools.ToolWithQuantity.Details.View.CurrentUserAssignment", [], CurrentUserAssignment, () => [["Id", string_type], ["Name", string_type], ["Quantity", string_type]]);
}

function DocumentSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => {
        let Documents;
        return append(singleton(createElement(DocumentTable, (Documents = ((length(props.Documents) > 5) ? take(5, props.Documents) : props.Documents), {
            AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                EntityId: DocumentId__get_unwrap(dto.Id),
            })])), "none", "button")),
            Documents: Documents,
            OnDownloadFile: (tupledArg) => {
                props.Dispatch(new Msg(30, [tupledArg[0], tupledArg[1]]));
            },
            UploadSuccessCallback: () => {
                props.Dispatch(new Msg(28, []));
            },
            UploadType: new UploadType_2(2, [props.ToolId]),
            UserData: props.UserData,
        }))), delay(() => {
            let elems, Title;
            return (length(props.Documents) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                ComponentState: "enabled",
                Label: t("general.show_more_data"),
                OnClick: () => {
                    setIsModalOpen(true);
                },
                TestId: "tool-selectcard-tooldetail-showmoredata-button",
                Variant: "blueButton",
            }), createElement(ModalSheet, (Title = t("general.documents"), {
                CloseButtonTestId: "",
                Content: createElement(DocumentTable, {
                    AdditionalColumns: singleton_1(new ColumnDefinition$1("changelog-history", "", t(""), (dto_1) => (new CellContent(1, [createElement(OpenChangelogButtonModalSheet, {
                        EntityId: DocumentId__get_unwrap(dto_1.Id),
                    })])), "none", "button")),
                    Documents: props.Documents,
                    OnDownloadFile: (tupledArg_1) => {
                        props.Dispatch(new Msg(30, [tupledArg_1[0], tupledArg_1[1]]));
                    },
                    UploadSuccessCallback: () => {
                        props.Dispatch(new Msg(28, []));
                    },
                    UploadType: new UploadType_2(2, [props.ToolId]),
                    UserData: props.UserData,
                }),
                Controls: empty_1(),
                IsModalOpen: patternInput_1[0],
                OnClose: () => {
                    setIsModalOpen(false);
                },
                Title: unwrap(Title),
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ToolsInCirculationSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsToolModalOpen = patternInput_1[1];
    const rows = map((d) => ({
        Name: d.ReceiverName,
        Quantity: d.Quantity,
    }), props.Tools);
    const table = (rows_1) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows_1), {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.name"), (row) => (new CellContent(0, [row.Name])), "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (row_1) => {
                let copyOfStruct;
                return new CellContent(0, [(copyOfStruct = row_1.Quantity, int32ToString(copyOfStruct))]);
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: false,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["name", "asc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "multiRow",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-tool-section"], ["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems_1 = toList(delay(() => append(singleton(table((length(rows) > 5) ? take(5, rows) : rows)), delay(() => {
        let elems;
        return (length(rows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsToolModalOpen(true);
            },
            TestId: "tool-toolwithquantity-toolsincirculation-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(rows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsToolModalOpen(false);
            },
            Title: t("tool.in_circulation"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function StockSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsToolModalOpen = patternInput_1[1];
    let responsibleStorageIds;
    const matchValue = props.UserData.Role;
    switch (matchValue) {
        case "toolManager": {
            responsibleStorageIds = map((storage_1) => storage_1.Id, filter((s) => contains(props.UserData.UserId, s.AssignedUserIds, {
                Equals: (x, y) => (x === y),
                GetHashCode: (x) => (stringHash(x) | 0),
            }), props.Storages));
            break;
        }
        case "user": {
            responsibleStorageIds = empty_1();
            break;
        }
        default:
            responsibleStorageIds = map((storage) => storage.Id, props.Storages);
    }
    const containsStorageId = (storageId) => contains(storageId, responsibleStorageIds, {
        Equals: equals,
        GetHashCode: (x_1) => (safeHash(x_1) | 0),
    });
    const patternInput_2 = reactApi.useState(undefined);
    const setIsDeleteStockPerStorageDialogOpen = patternInput_2[1];
    const isDeleteStockPerStorageDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setIsMinimumStockQuantityDialogOpen = patternInput_3[1];
    const isMinimumStockQuantityDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setIsStockChangeDialogOpen = patternInput_4[1];
    const patternInput_5 = reactApi.useState(undefined);
    const setIsChangeStorageSpaceDialogOpen = patternInput_5[1];
    const isChangeStorageSpaceDialogOpen = patternInput_5[0];
    const patternInput_6 = reactApi.useState(undefined);
    const setIsChangeStorageDialogOpen = patternInput_6[1];
    const isChangeStorageDialogOpen = patternInput_6[0];
    const rows = map((stockPerStorage) => ({
        MinimumQuantity: unwrap(stockPerStorage.MinimumStockQuantity),
        Name: stockPerStorage.StorageName,
        QRCode: isEmpty(stockPerStorage.QRCodeIds) ? "" : reduce((e1, e2) => concat(e1, ", ", ...e2), stockPerStorage.QRCodeIds),
        Stock: stockPerStorage.Stock,
        StorageId: new StorageId_2(parse(stockPerStorage.StorageId)),
        StorageSpace: stockPerStorage.StorageSpace,
    }), props.StockPerStorages);
    const table = (rows_1) => {
        let TableRows, Options, matchValue_2;
        return createElement(Table, (TableRows = toArray(rows_1), (Options = {
            BorderStyle: "row",
            CSVDownload: false,
            ConfigurableColumns: false,
            CustomTableFilters: false,
            DefaultSortColumn: ["name", "asc"],
            Fullscreen: false,
            GlobalSearch: false,
            RowSelection: "singleRow",
            SaveTableConfiguration: false,
        }, {
            ColumnDefinitions: [new ColumnDefinition$1("name", "", t("general.storage"), (row) => (new CellContent(0, [row.Name])), "none", "text"), new ColumnDefinition$1("storage", "", t("tool.storage_space"), (row_1) => (new CellContent(0, [row_1.StorageSpace])), "none", "text"), new ColumnDefinition$1("stock", "", t("tool.storage_stock"), (row_2) => {
                let copyOfStruct;
                return new CellContent(0, [(copyOfStruct = row_2.Stock, int32ToString(copyOfStruct))]);
            }, "none", "text"), new ColumnDefinition$1("minimum-quantity", "", t("general.minimum_quantity"), (row_3) => {
                const matchValue_1 = row_3.MinimumQuantity;
                return (matchValue_1 != null) ? (new CellContent(0, [int32ToString(matchValue_1)])) : (new CellContent(0, [""]));
            }, "none", "text"), new ColumnDefinition$1("qrCode", "", t("general.qr_code"), (row_4) => (new CellContent(0, [row_4.QRCode])), "none", "text")],
            Controls: (matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? ofArray([new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                if (isEmpty(selectedSps)) {
                    setIsStockChangeDialogOpen([true, undefined]);
                }
                else {
                    const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                    if (matchValue_3 == null) {
                    }
                    else {
                        const selectedStorageId_1 = matchValue_3;
                        if (containsStorageId(selectedStorageId_1)) {
                            setIsStockChangeDialogOpen([true, selectedStorageId_1]);
                        }
                    }
                }
            }, false, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                if (isEmpty(selectedSps_1)) {
                }
                else {
                    const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                    if (matchValue_4 == null) {
                    }
                    else {
                        const selectedStorageId_3 = matchValue_4;
                        if (containsStorageId(selectedStorageId_3[1])) {
                            setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                if (isEmpty(selectedSps_2)) {
                }
                else {
                    setIsChangeStorageDialogOpen(tryHead(map((selectedSps_3) => StorageId__get_unwrap(selectedSps_3.StorageId), selectedSps_2)));
                }
            }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_4) => {
                if (isEmpty(selectedSps_4)) {
                }
                else {
                    const matchValue_5 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_4));
                    if (matchValue_5 == null) {
                    }
                    else {
                        const selectedStorageId_6 = matchValue_5;
                        if (containsStorageId(selectedStorageId_6)) {
                            setIsMinimumStockQuantityDialogOpen(selectedStorageId_6);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_5) => {
                if (isEmpty(selectedSps_5)) {
                }
                else {
                    const matchValue_6 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_5));
                    if (matchValue_6 == null) {
                    }
                    else {
                        const selectedStorageId_8 = matchValue_6;
                        if (containsStorageId(selectedStorageId_8)) {
                            setIsDeleteStockPerStorageDialogOpen(selectedStorageId_8);
                        }
                    }
                }
            }, true, false, "")]) : ((matchValue_2 === "toolManager") ? ofArray([new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                if (isEmpty(selectedSps)) {
                    setIsStockChangeDialogOpen([true, undefined]);
                }
                else {
                    const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                    if (matchValue_3 == null) {
                    }
                    else {
                        const selectedStorageId_1 = matchValue_3;
                        if (containsStorageId(selectedStorageId_1)) {
                            setIsStockChangeDialogOpen([true, selectedStorageId_1]);
                        }
                    }
                }
            }, false, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                if (isEmpty(selectedSps_1)) {
                }
                else {
                    const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                    if (matchValue_4 == null) {
                    }
                    else {
                        const selectedStorageId_3 = matchValue_4;
                        if (containsStorageId(selectedStorageId_3[1])) {
                            setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                if (isEmpty(selectedSps_2)) {
                }
                else {
                    setIsChangeStorageDialogOpen(tryHead(map((selectedSps_3) => StorageId__get_unwrap(selectedSps_3.StorageId), selectedSps_2)));
                }
            }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_4) => {
                if (isEmpty(selectedSps_4)) {
                }
                else {
                    const matchValue_5 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_4));
                    if (matchValue_5 == null) {
                    }
                    else {
                        const selectedStorageId_6 = matchValue_5;
                        if (containsStorageId(selectedStorageId_6)) {
                            setIsMinimumStockQuantityDialogOpen(selectedStorageId_6);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_5) => {
                if (isEmpty(selectedSps_5)) {
                }
                else {
                    const matchValue_6 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_5));
                    if (matchValue_6 == null) {
                    }
                    else {
                        const selectedStorageId_8 = matchValue_6;
                        if (containsStorageId(selectedStorageId_8)) {
                            setIsDeleteStockPerStorageDialogOpen(selectedStorageId_8);
                        }
                    }
                }
            }, true, false, "")]) : ((matchValue_2 === "user") ? empty_1() : ofArray([new TableControl$1(t("tool.update_stock"), Warehouse_1(), (selectedSps) => {
                if (isEmpty(selectedSps)) {
                    setIsStockChangeDialogOpen([true, undefined]);
                }
                else {
                    const matchValue_3 = tryHead(map((selectedTool) => selectedTool.StorageId, selectedSps));
                    if (matchValue_3 == null) {
                    }
                    else {
                        const selectedStorageId_1 = matchValue_3;
                        if (containsStorageId(selectedStorageId_1)) {
                            setIsStockChangeDialogOpen([true, selectedStorageId_1]);
                        }
                    }
                }
            }, false, false, ""), new TableControl$1(t("tool.change_storage_space"), Location_Building_Search(), (selectedSps_1) => {
                if (isEmpty(selectedSps_1)) {
                }
                else {
                    const matchValue_4 = tryHead(map((selectedTool_1) => [selectedTool_1.StorageSpace, selectedTool_1.StorageId], selectedSps_1));
                    if (matchValue_4 == null) {
                    }
                    else {
                        const selectedStorageId_3 = matchValue_4;
                        if (containsStorageId(selectedStorageId_3[1])) {
                            setIsChangeStorageSpaceDialogOpen(selectedStorageId_3);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("tool.switch_storage"), Transfer_Cart(), (selectedSps_2) => {
                if (isEmpty(selectedSps_2)) {
                }
                else {
                    setIsChangeStorageDialogOpen(tryHead(map((selectedSps_3) => StorageId__get_unwrap(selectedSps_3.StorageId), selectedSps_2)));
                }
            }, false, false, ""), new TableControl$1(t("general.minimum_quantity_update"), Notification_Alarm_1(), (selectedSps_4) => {
                if (isEmpty(selectedSps_4)) {
                }
                else {
                    const matchValue_5 = tryHead(map((selectedTool_2) => selectedTool_2.StorageId, selectedSps_4));
                    if (matchValue_5 == null) {
                    }
                    else {
                        const selectedStorageId_6 = matchValue_5;
                        if (containsStorageId(selectedStorageId_6)) {
                            setIsMinimumStockQuantityDialogOpen(selectedStorageId_6);
                        }
                    }
                }
            }, true, false, ""), new TableControl$1(t("general.delete"), Recycle_Bin_1(), (selectedSps_5) => {
                if (isEmpty(selectedSps_5)) {
                }
                else {
                    const matchValue_6 = tryHead(map((selectedTool_3) => selectedTool_3.StorageId, selectedSps_5));
                    if (matchValue_6 == null) {
                    }
                    else {
                        const selectedStorageId_8 = matchValue_6;
                        if (containsStorageId(selectedStorageId_8)) {
                            setIsDeleteStockPerStorageDialogOpen(selectedStorageId_8);
                        }
                    }
                }
            }, true, false, "")])))),
            Options: Options,
            TableKey: "not-defined-table",
            TableRows: TableRows,
        })));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-stock-section"], ["className", join(" ", ["flex", "flex-col", "bg-white"])], (elems_1 = toList(delay(() => {
        let matchValue_7;
        return append((matchValue_7 = isDeleteStockPerStorageDialogOpen, (matchValue_7 == null) ? (empty()) : singleton(createElement(ToolWithQuantityStockPerStorageDeleteDialog, {
            IsOpen: isDeleteStockPerStorageDialogOpen != null,
            OnClose: () => {
                setIsDeleteStockPerStorageDialogOpen(undefined);
            },
            StorageId: matchValue_7,
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
            },
            ToolId: new ToolId_4(parse(props.Tool.Id)),
        }))), delay(() => {
            let matchValue_8;
            return append((matchValue_8 = isMinimumStockQuantityDialogOpen, (matchValue_8 == null) ? (empty()) : singleton(createElement(MinimumStockQuantityDialog, {
                IsOpen: isMinimumStockQuantityDialogOpen != null,
                OnClose: () => {
                    setIsMinimumStockQuantityDialogOpen(undefined);
                },
                StorageId: matchValue_8,
                SuccessCallback: () => {
                    props.Dispatch(new Msg(9, []));
                },
                ToolId: new ToolId_4(parse(props.Tool.Id)),
            }))), delay(() => {
                let matchValue_9, selectedStorage_2, ToolId_2;
                return append((matchValue_9 = patternInput_4[0], (matchValue_9 == null) ? (empty()) : ((selectedStorage_2 = matchValue_9, singleton(createElement(ChangeStockDialog, (ToolId_2 = (new ToolId_4(parse(props.Tool.Id))), {
                    IsOpen: selectedStorage_2[0],
                    OnClose: () => {
                        setIsStockChangeDialogOpen(undefined);
                    },
                    StorageId: unwrap(selectedStorage_2[1]),
                    Storages: filter((storage_2) => containsStorageId(storage_2.Id), props.Storages),
                    SuccessCallback: () => {
                        props.Dispatch(new Msg(9, []));
                    },
                    ToolId: ToolId_2,
                })))))), delay(() => {
                    let matchValue_10;
                    return append((matchValue_10 = isChangeStorageSpaceDialogOpen, (matchValue_10 == null) ? (empty()) : singleton(createElement(ChangeStorageSpaceDialog, {
                        IsEditableForUser: true,
                        IsOpen: isChangeStorageSpaceDialogOpen != null,
                        OnClose: () => {
                            setIsChangeStorageSpaceDialogOpen(undefined);
                        },
                        StorageId: matchValue_10[1],
                        StorageSpace: matchValue_10[0],
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(9, []));
                        },
                        ToolId: new ToolId_4(parse(props.Tool.Id)),
                    }))), delay(() => append(singleton(createElement(ChangeStorageDialog, {
                        IsOpen: isChangeStorageDialogOpen != null,
                        OnClose: () => {
                            setIsChangeStorageDialogOpen(undefined);
                        },
                        SelectedStorageId: unwrap(isChangeStorageDialogOpen),
                        Storages: filter((storage_3) => containsStorageId(storage_3.Id), props.Storages),
                        SuccessCallback: () => {
                            props.Dispatch(new Msg(9, []));
                        },
                        Tool: props.Tool,
                        UserData: props.UserData,
                    })), delay(() => append(singleton(table((length(rows) > 5) ? take(5, rows) : rows)), delay(() => {
                        let elems;
                        return (length(rows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
                            ComponentState: "enabled",
                            Label: t("general.show_more_data"),
                            OnClick: () => {
                                setIsToolModalOpen(true);
                            },
                            TestId: "tool-toolwithquantity-tooldetail-showmoredata-button",
                            Variant: "blueButton",
                        }), createElement(ModalSheet, {
                            CloseButtonTestId: "",
                            Content: table(rows),
                            Controls: empty_1(),
                            IsModalOpen: patternInput_1[0],
                            OnClose: () => {
                                setIsToolModalOpen(false);
                            },
                            Title: t("tool.storage_stock"),
                        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
                    }))))));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function HistorySection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsHistoryModalOpen = patternInput_1[1];
    const patternInput_2 = reactApi.useState(undefined);
    const setAssignmentProtocolParams = patternInput_2[1];
    const table = (rows) => {
        let TableRows;
        return createElement(Table, (TableRows = toArray(rows), {
            ColumnDefinitions: [new ColumnDefinition$1("timestamp", "", t("general.date"), (dto) => (new CellContent(7, [dto.Timestamp])), "none", "dateTime"), new ColumnDefinition$1("eventType", "", t("general.event"), (dto_1) => (new CellContent(0, [t(Helper_historyTypeToTranslationString(dto_1.EventType))])), "select", "text"), new ColumnDefinition$1("comment", "", t("general.comment"), (dto_2) => {
                const matchValue = dto_2.Event;
                return (matchValue == null) ? (new CellContent(0, [t(dto_2.Comment)])) : (new CellContent(0, [Helper_displayHistoryComment(t(matchValue), dto_2.Comment)]));
            }, "none", "text"), new ColumnDefinition$1("quantity", "", t("general.quantity_3"), (dto_3) => (new CellContent(0, [int32ToString(dto_3.Quantity)])), "none", "text"), new ColumnDefinition$1("receiver", "", t("general.receiver"), (dto_4) => {
                let matchValue_1;
                return new CellContent(0, [(matchValue_1 = dto_4.ReceiverInformation, (matchValue_1 == null) ? "" : matchValue_1.Name)]);
            }, "text", "text"), new ColumnDefinition$1("sender", "", t("general.sender"), (dto_5) => (new CellContent(0, [dto_5.SenderInformation.Name])), "text", "text"), new ColumnDefinition$1("signatureUrl", "", t("general.signature"), (dto_6) => {
                let matchValue_2;
                return new CellContent(4, [(matchValue_2 = dto_6.ReceiverInformation, (matchValue_2 != null) ? defaultArg(map_1((x) => x, matchValue_2.SignatureUrl), "") : "")]);
            }, "none", "image"), new ColumnDefinition$1("storage", "", t("general.storage"), (dto_7) => (new CellContent(0, [defaultArg(map_1((storage) => storage.Name, dto_7.StorageInformation), "")])), "text", "text"), new ColumnDefinition$1("action", "", "", (dto_8) => {
                const matchValue_3 = dto_8.EventType;
                switch (matchValue_3) {
                    case "problemReported":
                    case "updatedStock":
                    case "updatedStorage":
                    case "inMaintenance":
                    case "retired":
                    case "activate":
                    case "lost":
                    case "addedToSet":
                    case "removedFromSet":
                    case "changeInformation":
                    case "releaseDate":
                    case "deleteReleaseDate":
                    case "stocktakingStorageCorrectionBooking":
                    case "stocktakingReceiverCorrectionBooking":
                    case "stocktakingCorrectionBooking":
                    case "procedureCompleted":
                    case "procedureCancelled":
                    case "inspectionResultCreated":
                        return new CellContent(0, [""]);
                    default:
                        return new CellContent(2, [t("assignment_protocol.open_assignment_protocol"), () => {
                            let AssignmentType, ReceiverName, StorageName, SignatureUrl, ImageUrl;
                            setAssignmentProtocolParams((AssignmentType = t(Helper_historyTypeToTranslationString(dto_8.EventType)), (ReceiverName = defaultArg(map_1((_arg_1) => _arg_1.Name, dto_8.ReceiverInformation), ""), (StorageName = map_1((_arg_2) => _arg_2.Name, dto_8.StorageInformation), (SignatureUrl = flatten(map_1((_arg_3) => _arg_3.SignatureUrl, dto_8.ReceiverInformation)), (ImageUrl = ((props.BusinessUnitImageUrl == null) ? props.CustomerConfiguration.ProtocolConfiguration.ImageUrl : props.BusinessUnitImageUrl), new AssignmentProtocolParams(AssignmentType, props.ToolName, props.InventoryNumber, dto_8.SenderInformation.Name, ReceiverName, props.CustomerConfiguration.ProtocolConfiguration.ProtocolVisibleFields.QrCodeIds ? (isEmpty(props.QrCodeIds) ? "" : reduce((list_1, code) => concat(list_1, ", ", ...code), props.QrCodeIds)) : undefined, StorageName, dto_8.Comment, undefined, SignatureUrl, dto_8.Timestamp, ImageUrl, dto_8.SenderImageUrls, dto_8.ReceiverImageUrls)))))));
                        }]);
                }
            }, "none", "text")],
            Controls: empty_1(),
            Options: {
                BorderStyle: "row",
                CSVDownload: true,
                ConfigurableColumns: false,
                CustomTableFilters: false,
                DefaultSortColumn: ["timestamp", "desc"],
                Fullscreen: false,
                GlobalSearch: false,
                RowSelection: "disabled",
                SaveTableConfiguration: false,
            },
            TableKey: "not-defined-table",
            TableRows: TableRows,
        }));
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-history-section"], ["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(AssignmentProtocolDialog, {
        AssignmentProtocolParams: unwrap(patternInput_2[0]),
        OnClose: () => {
            setAssignmentProtocolParams(undefined);
        },
    })), delay(() => append(singleton(table((length(props.HistoryRows) > 5) ? take(5, props.HistoryRows) : props.HistoryRows)), delay(() => {
        let elems;
        return (length(props.HistoryRows) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsHistoryModalOpen(true);
            },
            TestId: "tool-toolwithquantity-historysection-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: table(props.HistoryRows),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsHistoryModalOpen(false);
            },
            Title: t("history.title"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function MasterDataSection(props) {
    let elems_4, elems_3;
    const t = useTranslation()[0];
    const purchaseDate = (d) => {
        if (d == null) {
            return "";
        }
        else {
            return toString(toLocalTime(d), "dd.MM.yyyy");
        }
    };
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-masterdata-section"], ["className", join(" ", ["bg-white", "pl-10", "pt-5", "pb-5", "rounded"])], (elems_4 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-2", "gap-20", "h-30"])], (elems_3 = toList(delay(() => {
        let elems_1, Title, elems;
        return append(singleton(reactElement("div", createObj(singleton_1((elems_1 = [createElement(PropertyList, (Title = t("general.master_data"), {
            Properties: toList(delay(() => append(singleton({
                Label: t("tool.manufacturer"),
                TestId: "master-data-manufacturer",
                Value: props.Tool.MasterData.Manufacturer,
            }), delay(() => append(singleton({
                Label: t("tool.model"),
                TestId: "master-data-model",
                Value: props.Tool.MasterData.Model,
            }), delay(() => append(singleton({
                Label: t("tool.displayname"),
                TestId: "master-data-display-name",
                Value: props.Tool.MasterData.DisplayName,
            }), delay(() => append(singleton({
                Label: t("tool.inventory_number"),
                TestId: "master-data-inventory-number",
                Value: props.Tool.MasterData.InventoryNumber,
            }), delay(() => append(singleton({
                Label: t("general.comment"),
                TestId: "master-data-comment",
                Value: props.Tool.MasterData.Comment,
            }), delay(() => {
                if (props.Customer.tag === 1) {
                    const matchValue_1 = props.Tool.CustomerSpecific;
                    switch (matchValue_1.tag) {
                        case 1:
                            return singleton({
                                Label: t("tool.prinzing.check_number"),
                                TestId: "master-data-prinzing-check-number",
                                Value: matchValue_1.fields[0].CheckNumber,
                            });
                        default: {
                            return empty();
                        }
                    }
                }
                else {
                    return empty();
                }
            })))))))))))),
            Title: unwrap(Title),
        })), reactElement("div", createObj(ofArray([["className", join(" ", ["mt-8"])], (elems = [createElement(CustomPropertiesPropertyList, {
            Currency: props.Currency,
            CustomProperties: props.Tool.CustomProperties,
            Title: t("tool.custom_properties"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))]))))), delay(() => {
            let elems_2, Title_2, p;
            const matchValue_2 = props.Tool.CommercialData;
            if (matchValue_2 == null) {
                return empty();
            }
            else {
                const commercialData = matchValue_2;
                return singleton(reactElement("div", createObj(singleton_1((elems_2 = [createElement(PropertyList, (Title_2 = t("tool.commercial_data"), {
                    Properties: ofArray([{
                        Label: t("general.supplier"),
                        TestId: "commercial-data-supplier",
                        Value: commercialData.Supplier,
                    }, {
                        Label: t("general.supplier_article_number"),
                        TestId: "commercial-data-supplier-article-number",
                        Value: commercialData.SupplierArticleNumber,
                    }, {
                        Label: t("general.purchase_price"),
                        TestId: "commercial-data-purchase-price",
                        Value: (p = commercialData.PurchasePrice, (p == null) ? "" : priceToString(p, props.Currency)),
                    }, {
                        Label: t("general.purchase_date"),
                        TestId: "commercial-data-purchase-date",
                        Value: purchaseDate(commercialData.PurchaseDate),
                    }, {
                        Label: t("general.gurantee_date"),
                        TestId: "commercial-data-guarantee-date",
                        Value: purchaseDate(commercialData.WarrantyDate),
                    }, {
                        Label: t("general.comment"),
                        TestId: "commercial-data-comment",
                        Value: commercialData.Comment,
                    }]),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])))));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
}

function ToolDetailsAreaAnchorMenu(props) {
    let elems;
    const patternInput = reactApi.useState("tool-with-quantity-overview-section");
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["print:hidden"])], (elems = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "tool-with-quantity-overview-section",
            Label: t("general.overview"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-masterdata-section",
            Label: t("general.master_data"),
        }), delay(() => append((isFeatureEnabled(new Feature(9, [])) ? true : isFeatureEnabled(new Feature(8, []))) ? singleton({
            Id: "appointments-section-id",
            Label: t("general.appointments"),
        }) : empty(), delay(() => append(singleton({
            Id: "reservations-section-id",
            Label: t("navbar.reservation"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-stock-section",
            Label: t("tool.storage_stock"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-tool-section",
            Label: t("tool.in_circulation"),
        }), delay(() => append(singleton({
            Id: "tool-with-quantity-document-section",
            Label: t("general.documents"),
        }), delay(() => append(singleton({
            Id: "barcodes-section-id",
            Label: t("general.qr_code"),
        }), delay(() => {
            const matchValue = props.UserData.Role;
            switch (matchValue) {
                case "user": {
                    return empty();
                }
                default:
                    return singleton({
                        Id: "tool-with-quantity-history-section",
                        Label: t("general.history"),
                    });
            }
        })))))))))))))))))),
        OnSelectAnchor: patternInput[1],
        SelectedAnchor: patternInput[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function OverView(props) {
    let elems_19;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsAssignDialogOpen = patternInput_1[1];
    const isAssignDialogOpen = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setIsUnassignDialogOpen = patternInput_2[1];
    const isUnassignDialogOpen = patternInput_2[0];
    const patternInput_3 = reactApi.useState(false);
    const setIsLostDialogOpen = patternInput_3[1];
    const isLostDialogOpen = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const setIsChangeStateToRetireDialogOpen = patternInput_4[1];
    const patternInput_5 = reactApi.useState(false);
    const setIsChangeStateToActiveDialogOpen = patternInput_5[1];
    const patternInput_6 = reactApi.useState(false);
    const setIsReturnNotificationDialogOpen = patternInput_6[1];
    const isReturnNotificationDialogOpen = patternInput_6[0];
    const patternInput_7 = reactApi.useState(false);
    const setIsSelfServiceAssignDialogOpen = patternInput_7[1];
    const isSelfServiceAssignDialogOpen = patternInput_7[0];
    const patternInput_8 = reactApi.useState(false);
    const setIsSelfServiceReturnDialogOpen = patternInput_8[1];
    const isSelfServiceReturnDialogOpen = patternInput_8[0];
    const storage = sumBy((value) => (value.Stock | 0), props.Tool.StockPerStorage, {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) | 0;
    const assignedUsers = sumBy((value_1) => (value_1.Quantity | 0), props.Tool.UserAssignments, {
        GetZero: () => 0,
        Add: (x_1, y_1) => ((x_1 + y_1) | 0),
    }) | 0;
    const actionButtons = toList(delay(() => {
        let Label;
        if (props.Tool.State.tag === 1) {
            return empty();
        }
        else {
            return append(singleton(createElement(TextButton, (Label = t("general.assign"), {
                ComponentState: "enabled",
                Icon: Following(),
                Label: Label,
                OnClick: () => {
                    setIsAssignDialogOpen(true);
                },
                TestId: "tool-toolwithquantity-overview-assign-button",
                Variant: "default",
            }))), delay(() => {
                let Label_1;
                return singleton(createElement(TextButton, (Label_1 = t("general.take_back"), {
                    ComponentState: "enabled",
                    Icon: Followers(),
                    Label: Label_1,
                    OnClick: () => {
                        setIsUnassignDialogOpen(true);
                    },
                    TestId: "tool-toolwithquantity-overview-unassign-button",
                    Variant: "default",
                })));
            }));
        }
    }));
    return reactElement("div", createObj(ofArray([["id", "tool-with-quantity-overview-section"], ["className", join(" ", ["flex", "flex-col", "grow"])], (elems_19 = toList(delay(() => append(isAssignDialogOpen ? singleton(createElement(AssignToolWithQuantityDialog, {
        IsOpen: isAssignDialogOpen,
        OnClose: () => {
            setIsAssignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isUnassignDialogOpen ? singleton(createElement(UnassignToolWithQuantityDialog, {
        IsOpen: isUnassignDialogOpen,
        OnClose: () => {
            setIsUnassignDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserData: props.UserData,
    })) : empty(), delay(() => append(isLostDialogOpen ? singleton(createElement(LostToolWithQuantityDialog, {
        IsOpen: isLostDialogOpen,
        OnClose: () => {
            setIsLostDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isReturnNotificationDialogOpen ? singleton(createElement(ReturnToolWithQuantityNotificationDialog, {
        IsOpen: isReturnNotificationDialogOpen,
        OnClose: () => {
            setIsReturnNotificationDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceAssignDialogOpen ? singleton(createElement(SelfServiceAssignToolWithQuantityDialog, {
        IsOpen: isSelfServiceAssignDialogOpen,
        OnClose: () => {
            setIsSelfServiceAssignDialogOpen(false);
        },
        SelfServiceStorages: filter((sps) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s) => {
                    if (unwrapStorageId(s.Id) === sps.StorageId) {
                        if (s.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s.AccessByUser, {
                                Equals: (x_2, y_2) => (x_2 === y_2),
                                GetHashCode: (x_2) => (stringHash(x_2) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Tool.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => append(isSelfServiceReturnDialogOpen ? singleton(createElement(SelfServiceReturnToolWithQuantityDialog, {
        IsOpen: isSelfServiceReturnDialogOpen,
        OnClose: () => {
            setIsSelfServiceReturnDialogOpen(false);
        },
        SelfServiceStorages: filter((sps_1) => {
            if (props.CustomerConfiguration.GlobalSelfServiceStorageActive) {
                return true;
            }
            else {
                return exists((s_1) => {
                    if (unwrapStorageId(s_1.Id) === sps_1.StorageId) {
                        if (s_1.IsSelfService) {
                            return true;
                        }
                        else {
                            return contains(props.UserData.UserId, s_1.AccessByUser, {
                                Equals: (x_3, y_3) => (x_3 === y_3),
                                GetHashCode: (x_3) => (stringHash(x_3) | 0),
                            });
                        }
                    }
                    else {
                        return false;
                    }
                }, props.Storages);
            }
        }, props.Tool.StockPerStorage),
        SuccessCallback: () => {
            props.Dispatch(new Msg(9, []));
        },
        Tool: props.Tool,
        UserId: props.UserData.UserId,
    })) : empty(), delay(() => {
        let elems_18, elems_2, elems, elems_1, matchValue_5, elems_17, elems_3, Images, matchValue_6, elems_16;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["bg-white", "pt-8", "pb-10", "rounded", "px-12"])], (elems_18 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "mb-12"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "gap-4"])], (elems = toList(delay(() => {
            let isSelfServiceUser, Label_2;
            const matchValue_1 = props.UserData.Role;
            switch (matchValue_1) {
                case "toolManager":
                case "user":
                    return append(contains(props.UserData.UserId, collect((x_4) => x_4, map((sps_2) => sps_2.AssignedUserIds, props.Tool.StockPerStorage)), {
                        Equals: (x_5, y_4) => (x_5 === y_4),
                        GetHashCode: (x_5) => (stringHash(x_5) | 0),
                    }) ? actionButtons : ((isSelfServiceUser = (props.CustomerConfiguration.GlobalSelfServiceStorageActive ? true : exists((s_2) => {
                        if (exists((sps_3) => (sps_3.StorageId === unwrapStorageId(s_2.Id)), props.Tool.StockPerStorage)) {
                            if (s_2.IsSelfService) {
                                return true;
                            }
                            else {
                                return contains(props.UserData.UserId, s_2.AccessByUser, {
                                    Equals: (x_6, y_5) => (x_6 === y_5),
                                    GetHashCode: (x_6) => (stringHash(x_6) | 0),
                                });
                            }
                        }
                        else {
                            return false;
                        }
                    }, props.Storages)), append(((isSelfServiceUser && equals(props.Tool.State, new ToolWithQuantityState(0, []))) && (storage > 0)) ? singleton(createElement(TextButton, (Label_2 = t("general.self_service_assign"), {
                        ComponentState: "enabled",
                        Icon: Following(),
                        Label: Label_2,
                        OnClick: () => {
                            setIsSelfServiceAssignDialogOpen(true);
                        },
                        TestId: "twq-detail-self-service-assign-button",
                        Variant: "default",
                    }))) : empty(), delay(() => {
                        let Label_3, Label_4;
                        return exists((ua) => (ua.ReceiverId === props.UserData.UserId), props.Tool.UserAssignments) ? ((isSelfServiceUser && props.CustomerConfiguration.IsStorageSelfServiceUserAuthorisedToReturnToolsWithoutNotification) ? singleton(createElement(TextButton, (Label_3 = t("general.self_service_return"), {
                            ComponentState: "enabled",
                            Icon: Followers(),
                            Label: Label_3,
                            OnClick: () => {
                                setIsSelfServiceReturnDialogOpen(true);
                            },
                            TestId: "twq-detail-self-service-return-button",
                            Variant: "default",
                        }))) : singleton(createElement(TextButton, (Label_4 = t("general.request_return"), {
                            ComponentState: "enabled",
                            Icon: Followers(),
                            Label: Label_4,
                            OnClick: () => {
                                setIsReturnNotificationDialogOpen(true);
                            },
                            TestId: "twq-detail-return-notification-button",
                            Variant: "default",
                        })))) : empty();
                    })))), delay(() => {
                        const matchValue_2 = props.UserData.Role;
                        switch (matchValue_2) {
                            case "user": {
                                return empty();
                            }
                            default:
                                return append(singleton(reactElement("div", {
                                    className: join(" ", ["grow"]),
                                })), delay(() => {
                                    let Label_5;
                                    return singleton(createElement(TextButton, (Label_5 = t("general.report_lost"), {
                                        ComponentState: "enabled",
                                        Icon: Shipment_Search(),
                                        Label: Label_5,
                                        OnClick: () => {
                                            setIsLostDialogOpen(true);
                                        },
                                        TestId: "tool-toolwithquantity-overview-lost-button",
                                        Variant: "default",
                                    })));
                                }));
                        }
                    }));
                default:
                    return actionButtons;
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_1 = toList(delay(() => append(singleton(createElement(StateChangeDialog, {
            IsOpen: patternInput_4[0],
            NewState: new ToolWithQuantityState(1, []),
            OnClose: () => {
                setIsChangeStateToRetireDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
            },
            ToolWithQuantity: props.Tool,
        })), delay(() => append(singleton(createElement(StateChangeDialog, {
            IsOpen: patternInput_5[0],
            NewState: new ToolWithQuantityState(0, []),
            OnClose: () => {
                setIsChangeStateToActiveDialogOpen(false);
            },
            SuccessCallback: () => {
                props.Dispatch(new Msg(9, []));
            },
            ToolWithQuantity: props.Tool,
        })), delay(() => {
            let Label_7, Label_6;
            const matchValue_3 = props.UserData.Role;
            switch (matchValue_3) {
                case "toolManager":
                case "user": {
                    return empty();
                }
                default:
                    return (props.Tool.State.tag === 1) ? singleton(createElement(TextButton, (Label_7 = t("tool.state_active"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Check(),
                        Label: Label_7,
                        OnClick: () => {
                            setIsChangeStateToActiveDialogOpen(true);
                        },
                        TestId: "tool-tooldetail-retired-state-button",
                        Variant: "default",
                    }))) : singleton(createElement(TextButton, (Label_6 = t("general.reject"), {
                        ComponentState: "enabled",
                        Icon: Shipment_Delivery_Fail(),
                        Label: Label_6,
                        OnClick: () => {
                            setIsChangeStateToRetireDialogOpen(true);
                        },
                        TestId: "tool-tooldetail-retired-state-button",
                        Variant: "default",
                    })));
            }
        })))))), ["children", reactApi.Children.toArray(Array.from(elems_1))]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement(NotificationArea, {
            IsCurrentUserStorageResponsible: (matchValue_5 = props.UserData.Role, (matchValue_5 === "system") ? true : ((matchValue_5 === "toolManager") ? exists((sps_4) => contains(props.UserData.UserId, sps_4.AssignedUserIds, {
                Equals: (x_7, y_6) => (x_7 === y_6),
                GetHashCode: (x_7) => (stringHash(x_7) | 0),
            }), props.Tool.StockPerStorage) : ((matchValue_5 === "user") ? exists((sps_4) => contains(props.UserData.UserId, sps_4.AssignedUserIds, {
                Equals: (x_7, y_6) => (x_7 === y_6),
                GetHashCode: (x_7) => (stringHash(x_7) | 0),
            }), props.Tool.StockPerStorage) : true))),
            NotificationToolType: new NotificationToolType_1(1, []),
            Notifications: props.Notifications,
            OnUpdate: () => {
                props.Dispatch(new Msg(9, []));
            },
            UserData: props.UserData,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "mb-8"])], (elems_17 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-16"])], (elems_3 = [createElement(MultipleImageWidget, (Images = map((image) => ({
            ImageUrl: image.ImageUrl,
            Position: image.Position,
        }), props.Tool.ToolImages), {
            CanEditImage: (matchValue_6 = props.UserData.Role, (matchValue_6 === "system") ? true : ((matchValue_6 === "toolManager") ? true : (!(matchValue_6 === "user")))),
            ComponentState: "enabled",
            FormImages: props.ToolImages,
            Images: Images,
            OnImagesChanged: (images) => {
                props.Dispatch(new Msg(12, [images]));
            },
            OnSave: () => {
                props.Dispatch(new Msg(13, []));
            },
        }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "ml-10"])], (elems_16 = toList(delay(() => append(singleton(reactElement("div", {
            className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
            children: t("general.state"),
        })), delay(() => {
            let elems_5, elems_4;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_4 = [createElement(ColoredDot, {
                Color: (props.Tool.State.tag === 1) ? "red" : "green",
            })], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement(TextValue, {
                FontWeight: "normal",
                TestId: "",
                Text: concat((props.Tool.State.tag === 1) ? t("general.retired") : t("general.active"), " ", ...defaultArg(map_1((date) => (("(" + toString(toLocalTime(date), "dd.MM.yyyy")) + ")"), props.Tool.StateDate), "")),
            })], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
                let matchValue_9, businessUnitName, elems_7, elems_6;
                return append(isFeatureEnabled(new Feature(17, [])) ? (props.AccountSettings.BusinessUnitsEnabled ? ((matchValue_9 = props.Tool.BusinessUnitName, (matchValue_9 == null) ? (empty()) : ((businessUnitName = matchValue_9, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], (elems_7 = [reactElement("div", {
                    className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                    children: t("business_units.business_unit"),
                }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center"])], (elems_6 = [createElement(TextValue, {
                    FontWeight: "normal",
                    TestId: "tool-details-business-unit",
                    Text: businessUnitName,
                })], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))))))) : empty()) : empty(), delay(() => {
                    let elems_8;
                    return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], ["data-test-id", "tool-with-quantity-total-stock-test-id"], (elems_8 = [t("general.total_stock")], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                        let elems_10;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_10 = toList(delay(() => {
                            let elems_9;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mr-1"])], (elems_9 = [createElement(ColoredDot, {
                                Color: (length(props.Storages) !== 0) ? "green" : "red",
                            })], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))), delay(() => singleton(createElement(TextValue, {
                                FontWeight: "normal",
                                TestId: "tool-with-quantity-storage-test-id",
                                Text: `${storage} ${t("unit.piece")}`,
                            }))));
                        })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))), delay(() => {
                            let elems_11;
                            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["min-w-full", "text-sm", "font-semibold", "mb-2"])], (elems_11 = [t("tool.in_circulation")], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                                let elems_12;
                                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-2"])], (elems_12 = toList(delay(() => singleton(createElement(TextValue, {
                                    FontWeight: "normal",
                                    TestId: "tool-with-quantity-assigedn-user-test-id",
                                    Text: `${assignedUsers} ${t("unit.piece")}`,
                                })))), ["children", reactApi.Children.toArray(Array.from(elems_12))])])))), delay(() => {
                                    let matchValue_10, lastSeen, elems_14, elems_13;
                                    return append((matchValue_10 = props.Tool.LastSeen, (matchValue_10 == null) ? (empty()) : ((lastSeen = matchValue_10, singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["mb-4"])], (elems_14 = [reactElement("div", {
                                        className: join(" ", ["text-sm", "font-semibold", "mb-2"]),
                                        children: t("general.last_seen"),
                                    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-row", "items-center", "mb-2"])], (elems_13 = [createElement(TextValue, {
                                        FontWeight: "normal",
                                        TestId: "",
                                        Text: `${toString(toLocalTime(lastSeen.ScannedAt), "dd.MM.yyyy HH:mm")} ${t("general.last_seen_by")} ${lastSeen.ScannedByUserName} (${(lastSeen.ScanMethod === "nfc_tag") ? t("general.nfc_tag") : t("general.qr_code")})`,
                                    })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))], ["children", reactApi.Children.toArray(Array.from(elems_14))])]))))))), delay(() => {
                                        let elems_15;
                                        return isFeatureEnabled(new Feature(3, [])) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_15 = [createElement(QuickOverviewList, {
                                            Currency: props.CustomerConfiguration.Currency,
                                            Elements: {
                                                CommercialData: unwrap(props.Tool.CommercialData),
                                                Custom: toList(delay(() => {
                                                    let Label_8;
                                                    return append(singleton((Label_8 = t("tool.manufacturer"), {
                                                        Group: t("general.master_data"),
                                                        Key: "tool-manufacturer-fav-field",
                                                        Label: Label_8,
                                                        Value: props.Tool.MasterData.Manufacturer,
                                                    })), delay(() => {
                                                        let Label_9;
                                                        return append(singleton((Label_9 = t("tool.model"), {
                                                            Group: t("general.master_data"),
                                                            Key: "tool-model-fav-field",
                                                            Label: Label_9,
                                                            Value: props.Tool.MasterData.Model,
                                                        })), delay(() => {
                                                            let Label_10;
                                                            return append(singleton((Label_10 = t("tool.displayname"), {
                                                                Group: t("general.master_data"),
                                                                Key: "tool-displayname-fav-field",
                                                                Label: Label_10,
                                                                Value: props.Tool.MasterData.DisplayName,
                                                            })), delay(() => {
                                                                let Label_11;
                                                                return append(singleton((Label_11 = t("tool.inventory_number"), {
                                                                    Group: t("general.master_data"),
                                                                    Key: "tool-inventorynumber-fav-field",
                                                                    Label: Label_11,
                                                                    Value: props.Tool.MasterData.InventoryNumber,
                                                                })), delay(() => {
                                                                    let Label_12;
                                                                    if (props.UserData.Customer.tag === 1) {
                                                                        const matchValue_13 = props.Tool.CustomerSpecific;
                                                                        switch (matchValue_13.tag) {
                                                                            case 1:
                                                                                return singleton((Label_12 = t("tool.prinzing.check_number"), {
                                                                                    Group: t("general.master_data"),
                                                                                    Key: "tool-prinzing-check-number-fav-field",
                                                                                    Label: Label_12,
                                                                                    Value: matchValue_13.fields[0].CheckNumber,
                                                                                }));
                                                                            default: {
                                                                                return empty();
                                                                            }
                                                                        }
                                                                    }
                                                                    else {
                                                                        return empty();
                                                                    }
                                                                }));
                                                            }));
                                                        }));
                                                    }));
                                                })),
                                                CustomProperties: props.Tool.CustomProperties,
                                            },
                                            IsDialogOpen: props.QuickOverviewDialog.IsOpen,
                                            IsLoading: props.QuickOverviewDialog.IsLoading,
                                            OnSave: (updatedVisibleKeys) => {
                                                props.Dispatch(new Msg(0, [updatedVisibleKeys]));
                                            },
                                            SetDialogOpen: (_arg_26) => {
                                                props.Dispatch(new Msg(1, []));
                                            },
                                            UserData: props.UserData,
                                            VisibleKeys: props.UserConfiguration.QuickOverviewConfiguration.ToolWithQuantityViewVisibleFieldKeys,
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_15))])])))) : empty();
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_16))])])))], ["children", reactApi.Children.toArray(Array.from(elems_17))])])))], ["children", reactApi.Children.toArray(Array.from(elems_18))])]))));
    })))))))))))))), ["children", reactApi.Children.toArray(Array.from(elems_19))])])));
}

function BarcodeSection(props) {
    let elems_1;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsModalOpen = patternInput_1[1];
    let tableData;
    const list_7 = collect((x) => x, map((stockPerStorage) => choose((qrCodeId) => ({
        QrCode: qrCodeId,
        StorageId: new StorageId_2(parse(stockPerStorage.StorageId)),
        StorageName: stockPerStorage.StorageName,
        StorageSpace: stockPerStorage.StorageSpace,
    }), stockPerStorage.QRCodeIds), props.StockPerStorage));
    tableData = append_1(choose((stockPerStorage_2) => ({
        QrCode: "",
        StorageId: new StorageId_2(parse(stockPerStorage_2.StorageId)),
        StorageName: stockPerStorage_2.StorageName,
        StorageSpace: stockPerStorage_2.StorageSpace,
    }), filter((stockPerStorage_1) => isEmpty(stockPerStorage_1.QRCodeIds), props.StockPerStorage)), list_7);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col"])], (elems_1 = toList(delay(() => append(singleton(createElement(QrCodeTableWithStorage, {
        Data: (length(tableData) > 5) ? take(5, tableData) : tableData,
        OnAssignQrCode: (tupledArg) => {
            props.Dispatch(new Msg(20, [tupledArg[0], tupledArg[1]]));
        },
        OnDeleteQrCodes: (tupledArg_1) => {
            props.Dispatch(new Msg(22, [tupledArg_1[0], tupledArg_1[1]]));
        },
        UserData: props.UserData,
    })), delay(() => {
        let elems;
        return (length(tableData) > 5) ? singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "mt-4", "mb-4"])], (elems = [createElement(Button, {
            ComponentState: "enabled",
            Label: t("general.show_more_data"),
            OnClick: () => {
                setIsModalOpen(true);
            },
            TestId: "tool-selectcard-tooldetail-showmoredata-button",
            Variant: "blueButton",
        }), createElement(ModalSheet, {
            CloseButtonTestId: "",
            Content: createElement(QrCodeTableWithStorage, {
                Data: tableData,
                OnAssignQrCode: (value_2) => {
                },
                OnDeleteQrCodes: (value_3) => {
                },
                UserData: props.UserData,
            }),
            Controls: empty_1(),
            IsModalOpen: patternInput_1[0],
            OnClose: () => {
                setIsModalOpen(false);
            },
            Title: t("general.qr_code"),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

export function ToolWithQuantityDetail(props) {
    let elems_12, elems_11, elems, Title, SubTitle, cats, matchValue, matchValue_1, matchValue_2, elems_10;
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(false);
    const setIsDeleteDialogOpen = patternInput_1[1];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "grow"])], (elems_12 = [createElement(OpenToolWithQuantityDeleteDialog, {
        IsOpen: patternInput_1[0],
        OnClose: () => {
            setIsDeleteDialogOpen(false);
        },
        SuccessCallback: () => {
            props.Dispatch(new Msg(17, []));
        },
        ToolId: new ToolId_4(parse(props.Tool.Id)),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,min(calc(100vw-16rem-2px-28px-11rem),80rem)]", "print:flex", "print:flex-col"])], (elems_11 = [reactElement("div", createObj(ofArray([["className", join(" ", ["col-span-2"])], (elems = [createElement(DetailViewHeader, (Title = ((props.Tool.MasterData.DisplayName !== "") ? props.Tool.MasterData.DisplayName : concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model)), (SubTitle = ((props.Tool.MasterData.DisplayName !== "") ? concat(props.Tool.MasterData.Manufacturer, " ", ...props.Tool.MasterData.Model) : undefined), {
        Badges: (cats = props.Tool.Categories, map((leaf) => createElement(Badge, {
            Color: leaf.ColorHex,
            Label: join(" > ", ofArray(split(leaf.CategoryName, [" > "], undefined, 0))),
            TestId: concat("category-badge-", ...leaf.CategoryId),
        }), filter((c) => !exists((o) => {
            if (o.CategoryName !== c.CategoryName) {
                return o.CategoryName.startsWith(c.CategoryName + " > ");
            }
            else {
                return false;
            }
        }, cats), cats))),
        OnBack: () => {
            RouterModule_nav(singleton_1("tools" + RouterModule_encodeQueryString(getQueryParams(undefined))), 1, 1);
        },
        OnDelete: unwrap((matchValue = props.UserData.Role, (matchValue === "system") ? (() => {
            setIsDeleteDialogOpen(true);
        }) : ((matchValue === "toolManager") ? (props.CustomerConfiguration.InventoryConfiguration.ToolManagerCanDeleteInventory ? (() => {
            setIsDeleteDialogOpen(true);
        }) : undefined) : ((matchValue === "user") ? undefined : (() => {
            setIsDeleteDialogOpen(true);
        }))))),
        OnDuplicate: unwrap((matchValue_1 = props.UserData.Role, (matchValue_1 === "system") ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_1 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_1 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "copy" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }))))),
        OnEdit: unwrap((matchValue_2 = props.UserData.Role, (matchValue_2 === "system") ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_2 === "toolManager") ? (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }) : ((matchValue_2 === "user") ? undefined : (() => {
            RouterModule_nav(ofArray(["toolswithquantity", props.Tool.Id, "edit" + RouterModule_encodeQueryString(getQueryParams(undefined))]), 1, 1);
        }))))),
        SubTitle: unwrap(SubTitle),
        Title: Title,
    })))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(ToolDetailsAreaAnchorMenu, {
        UserData: props.UserData,
    }), reactElement("div", createObj(singleton_1((elems_10 = toList(delay(() => append(singleton(createElement(OverView, {
        AccountSettings: props.AccountSettings,
        CustomerConfiguration: props.CustomerConfiguration,
        Dispatch: props.Dispatch,
        Notifications: props.Notifications,
        QuickOverviewDialog: props.QuickOverviewDialog,
        Storages: props.Storages,
        Tool: props.Tool,
        ToolImages: props.ToolImages,
        UserConfiguration: props.UserConfiguration,
        UserData: props.UserData,
    })), delay(() => {
        let elems_2, elems_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["pt-10"])], (elems_2 = [reactElement("div", createObj(ofArray([["className", join(" ", ["font-[600]", "pb-4", "text-sm"])], (elems_1 = [t("general.master_data")], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(MasterDataSection, {
            AccountSettings: props.AccountSettings,
            Currency: props.CustomerConfiguration.Currency,
            Customer: props.UserData.Customer,
            Tool: props.Tool,
        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let elems_3, Title_1;
            return append((isFeatureEnabled(new Feature(9, [])) ? true : isFeatureEnabled(new Feature(8, []))) ? append(singleton(reactElement("section", createObj(ofArray([["id", "appointments-section-id"], (elems_3 = [createElement(TableContainer, (Title_1 = t("general.appointments"), {
                Content: createElement(AppointmentsSection, {
                    Dispatch: props.Dispatch,
                    Documents: props.Documents,
                    ReceiverNames: props.ReceiverNames,
                    ToolWithQuantity: props.Tool,
                    UserData: props.UserData,
                }),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                let elems_4, Title_2;
                return singleton(reactElement("section", createObj(ofArray([["id", "reservations-section-id"], (elems_4 = [createElement(TableContainer, (Title_2 = t("navbar.reservation"), {
                    Content: createElement(ReservationSection, {
                        Dispatch: props.Dispatch,
                        ReceiverNames: props.ReceiverNames,
                        ToolWithQuantity: props.Tool,
                        UserData: props.UserData,
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
            })) : empty(), delay(() => {
                let elems_5, Title_3;
                return append(singleton(reactElement("section", createObj(singleton_1((elems_5 = [createElement(TableContainer, (Title_3 = t("tool.storage_stock"), {
                    Content: createElement(StockSection, {
                        Dispatch: props.Dispatch,
                        StockPerStorages: props.Tool.StockPerStorage,
                        Storages: props.Storages,
                        Tool: props.Tool,
                        UserData: props.UserData,
                        UserId: props.UserData.UserId,
                    }),
                    Title: unwrap(Title_3),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))]))))), delay(() => {
                    let elems_6, Title_4;
                    return append(singleton(reactElement("section", createObj(singleton_1((elems_6 = [createElement(TableContainer, (Title_4 = t("tool.in_circulation"), {
                        Content: createElement(ToolsInCirculationSection, {
                            Tools: props.Tool.UserAssignments,
                        }),
                        Title: unwrap(Title_4),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_6))]))))), delay(() => {
                        let elems_7, Title_5;
                        return append(singleton(reactElement("section", createObj(ofArray([["id", "tool-with-quantity-document-section"], (elems_7 = [createElement(TableContainer, (Title_5 = t("general.documents"), {
                            Content: createElement(DocumentSection, {
                                Dispatch: props.Dispatch,
                                Documents: props.Documents,
                                IsVisibleForUser: true,
                                ToolId: new ToolId_4(parse(props.Tool.Id)),
                                UserData: props.UserData,
                            }),
                            Title: unwrap(Title_5),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                            let elems_8, Title_6;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "barcodes-section-id"], (elems_8 = [createElement(TableContainer, (Title_6 = t("general.qr_code"), {
                                Content: createElement(BarcodeSection, {
                                    Dispatch: props.Dispatch,
                                    StockPerStorage: props.Tool.StockPerStorage,
                                    Storages: props.Storages,
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_6),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                let elems_9, Title_7, Title_8, ToolName, Title_9, matchValue_4;
                                const matchValue_3 = props.UserData.Role;
                                switch (matchValue_3) {
                                    case "user": {
                                        return empty();
                                    }
                                    default:
                                        return singleton(reactElement("section", createObj(ofArray([["id", "history-section-id"], (elems_9 = [createElement(TableContainerWithTabs, (Title_7 = t("history.title"), {
                                            Tab1: (Title_8 = t("history.events"), {
                                                Content: createElement(HistorySection, (ToolName = ToolWithQuantityDetailDto__ReadableDisplayName(props.Tool), {
                                                    BusinessUnitImageUrl: unwrap(props.BusinessUnitImageUrl),
                                                    CustomerConfiguration: props.CustomerConfiguration,
                                                    HistoryRows: props.History,
                                                    InventoryNumber: props.Tool.MasterData.InventoryNumber,
                                                    QrCodeIds: collect((x) => x, map((sps) => sps.QRCodeIds, props.Tool.StockPerStorage)),
                                                    ToolName: ToolName,
                                                })),
                                                Title: Title_8,
                                            }),
                                            Tab2: (Title_9 = t("history.changes"), {
                                                Content: (matchValue_4 = props.Changelogs, (matchValue_4.tag === 0) ? createElement(Skeleton, {
                                                    Variant: "table",
                                                }) : createElement(ChangelogTable, {
                                                    Changelogs: matchValue_4.fields[0],
                                                })),
                                                OnSelect: () => {
                                                    props.Dispatch(new Msg(38, []));
                                                },
                                                Title: Title_9,
                                            }),
                                            Title: unwrap(Title_7),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                                }
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_10))]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])));
}

export function ToolWithQuantityDetailView(props) {
    const patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram((tupledArg) => initViewToolWithQuantity(tupledArg[0], tupledArg[1]), update_1, (_arg, _arg_1) => {
    }), [props.ToolId, props.UserData], undefined);
    const state_1 = patternInput[0];
    const matchValue = state_1.Tool;
    const matchValue_1 = state_1.History;
    const matchValue_2 = state_1.Storages;
    const matchValue_3 = state_1.UserConfiguration;
    const matchValue_4 = state_1.Documents;
    const matchValue_5 = state_1.Receivers;
    const matchValue_6 = state_1.Notifications;
    const matchValue_7 = state_1.CustomerConfiguration;
    const matchValue_8 = state_1.AccountSettings;
    const matchValue_9 = state_1.BusinessUnitImageUrl;
    let matchResult, accountSettings, businessUnitImageUrl, customerConfiguration, documents, history, notifications, receiverNames, storages, tool, userConfiguration;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_1.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_2.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_3.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_4.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_5.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_6.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_7.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_8.tag === 0) {
        matchResult = 1;
    }
    else if (matchValue_9.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        accountSettings = matchValue_8.fields[0];
        businessUnitImageUrl = matchValue_9.fields[0];
        customerConfiguration = matchValue_7.fields[0];
        documents = matchValue_4.fields[0];
        history = matchValue_1.fields[0];
        notifications = matchValue_6.fields[0];
        receiverNames = matchValue_5.fields[0];
        storages = matchValue_2.fields[0];
        tool = matchValue.fields[0];
        userConfiguration = matchValue_3.fields[0];
    }
    switch (matchResult) {
        case 0:
            return createElement(ToolWithQuantityDetail, {
                AccountSettings: accountSettings,
                BusinessUnitImageUrl: unwrap(businessUnitImageUrl),
                Changelogs: state_1.Changelogs,
                CustomerConfiguration: customerConfiguration,
                Dispatch: patternInput[1],
                Documents: documents,
                History: history,
                Notifications: notifications,
                QuickOverviewDialog: state_1.QuickOverviewDialog,
                ReceiverNames: receiverNames,
                State: state_1,
                Storages: storages,
                Tool: tool,
                ToolImages: state_1.ToolImages,
                UserConfiguration: userConfiguration,
                UserData: state_1.UserData,
            });
        default:
            return createElement(Skeleton, {
                Variant: "detail",
            });
    }
}

